
import { post, token, get, DEV_TOKEN } from './api.js';
import { writable } from 'svelte/store';

/**
 * Send Mail.
 */
export function send_email(id, type, template_id, invitation_id, guest_id, email) {
    return post('mailing/',
        {
            id: id,
            type: type,
            template_id: template_id,
            recipients: [{
                invitation_id: invitation_id,
                id: guest_id,
                email: email
            }]
        }, token || DEV_TOKEN);
}

/**
 * Send Mail.
 */
export function send_bulk_email(id, type, template_id, recipients) {
    let payload = {
        id: id,
        type: type,
        recipients: recipients
    };

    if (template_id) {
        payload.template_id = template_id;
    }
    return post('mailing/', payload, token || DEV_TOKEN);
}

export async function load(id, groupby) {

    if (groupby === undefined) {
        groupby = false;
    }

    return get(`mailing/?id=${id}`, token || DEV_TOKEN)
        .then(r => r.data)
        .then(d => {
            return groupby ? groupBy(d, "invitation_id") : d;
        })
        .catch(e => {
            return [];
        });
}

export async function count(id) {

    return get(`mailing/?id=${id}&count`, token || DEV_TOKEN)
        .then(r => r.data)
        .then(d => {
            return d;
        })
        .catch(e => {
            return [];
        });
}